import React         from 'react';
import ReactDom      from 'react-dom';
import Moment        from 'moment';

import Const         from 'fw_const';
import Utils         from 'utils';

import ContentsModal from '@partials/contents-modal';
import InsightLogin  from '@partials/insight-login';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

class ProjectInsightLogin extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
    
    let data = this.props.data;
    
    let event = data.event; 
    event.showInsightLogin = this.showInsightLogin.bind(this);
    data.event.updateData.bind(this)('event', event);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      modal       : false,
      detail      : {},
      delete_mode : false,
    };
  }
  // -------------------------------------------------------
  
  /*
   * 投稿コンテンツ一覧の取得
   */
  showInsightLogin() {
    Utils.request.bind(this)('/api/insight/detail', { project_id: this.props.project_id, insta_user_id: this.props.insta_user_id },
      function(res){
        
        this.setState({ detail: res.body.data });
        
        // モーダル表示
        this.toogleModal.bind(this)(true);
        
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  /*
   * モーダルの操作
   */
  toogleModal(flg) {
    this.setState({ modal: flg });
    
    if( flg == true  ) Utils.fixedContents();
    if( flg == false ) Utils.unlockFixedContents();
  }
  // -------------------------------------------------------
  
  /*
   * モーダルの操作
   */
  toogleMode() {
    this.setState({ delete_mode: !(this.state.delete_mode == true) });
  }
  // -------------------------------------------------------
  
  render() {
    let detail = this.state.detail;
    
    return (
      <div className="project-insight-login">
        <ContentsModal
          view     = {this.state.modal}
          width    = {600}
          height   = {500}
          close_ev = {this.toogleModal.bind(this, false)}
          html     = {
            <div className="modal-item">
              <div className="modal-main-contents">
                
                <h2>DM用のインサイト連携</h2>
                
                <div className="insight-login-option">
                  <InsightLogin refresh_ev={this.showInsightLogin.bind(this)} />
                  
                  { (this.state.delete_mode !== true)
                    ? <div className="delete-button on" onClick={this.toogleMode.bind(this)}>削除モード</div>
                    : <div className="delete-button off" onClick={this.toogleMode.bind(this)}>削除モード</div>
                  }
                </div>
                
                { (this.state.delete_mode !== true)
                  ? <AccountList detail={detail} refresh_ev={this.showInsightLogin.bind(this)} />
                  : <DeleteList detail={detail} refresh_ev={this.showInsightLogin.bind(this)} />
                }
                
              </div>
            </div>
          }
        />
      </div>
    );
  }
}
// -------------------------------------------------------

class AccountList extends React.Component {
  SetInfluencerToggle(insta_user_id, flg) {
    if( flg == false ){
      let chk = confirm('アカウントの状態をOFFに設定します。DMが使用できなくなりますがよろしいですか？');
      if( chk == false ) return;
    }
    
    Utils.request.bind(this)('/api/insight/update', { insta_user_id: insta_user_id, flg: flg },
      function(res){
        this.props.refresh_ev.bind(this)();
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let detail = this.props.detail;
    
    if( detail.account_list == undefined || detail.account_list.length == 0 ){
      return null;
    }
    
    return (
      <div className="dm-account-list">
        <h6>連携済みアカウント ({detail.account_list.length})</h6>
        <ul>
          { detail.account_list.map((d, key) => {
            let flg = (d.is_active == 0) ? 'off' : 'on';
            
            let alert_html = null;
            if( d.error_flg == 1 ) alert_html = <h3><i className="material-icons">warning</i>{d.error_code}</h3>;
            
            return (
              <OverlayTrigger key={key} placement="top" delayShow={50} overlay={<Tooltip><div><h6>@{d.insta_id}</h6><h2>{d.full_name}</h2>{alert_html}</div></Tooltip>}>
                <li className={flg}>
                  <p className="thumbnail"><img src={d.thumbnail} onError={(e)=>{e.target.src="/images/default.jpg"}} /></p>
                  <p className="insta-id">@{d.insta_id}</p>
                  
                  { (d.error_flg == 0)
                    ? <div className="toggle-item">
                        { (d.is_active == 1)
                          ? <div className="toggle on" onClick={this.SetInfluencerToggle.bind(this, d.insta_user_id, false)}>ON</div>
                          : <div className="toggle off" onClick={this.SetInfluencerToggle.bind(this, d.insta_user_id, true)}>OFF</div>
                        }
                      </div>
                    : <div className="toggle-error"><i className="material-icons">warning</i></div>
                  }
                </li>
              </OverlayTrigger>
            );
          })}
        </ul>
        
      </div>
    );
  }
}
// -------------------------------------------------------

class DeleteList extends React.Component {
  SetInfluencerToggle(insta_user_id) {
    let chk = confirm('アカウントを削除します。よろしいですか？');
    if( chk == false ) return;
    
    Utils.request.bind(this)('/api/insight/update', { insta_user_id: insta_user_id, flg: false, mode: 'delete' },
      function(res){
        this.props.refresh_ev.bind(this)();
      }.bind(this)
    );
  }
  // -------------------------------------------------------
  
  render() {
    let detail = this.props.detail;
    
    if( detail.account_list == undefined || detail.account_list.length == 0 ){
      return null;
    }
    
    let delete_list = [];
    detail.account_list.map((d) => { if( d.is_active == 0 ) delete_list.push(d); });
    
    return (
      <div className="dm-account-list">
        <h6>削除対象アカウント ({delete_list.length})</h6>
        <ul>
          { delete_list.map((d, key) => {
            if( d.is_active == 1 ) return null;
            
            return (
              <OverlayTrigger key={key} placement="top" delayShow={50} overlay={<Tooltip><div><h6>@{d.insta_id}</h6><h2>{d.full_name}</h2></div></Tooltip>}>
                <li className='on' onClick={this.SetInfluencerToggle.bind(this, d.insta_user_id)}>
                  <p className="thumbnail"><img src={d.thumbnail} onError={(e)=>{e.target.src="/images/default.jpg"}} /></p>
                  <p className="insta-id">@{d.insta_id}</p>
                  <p className="delete-mode">削除</p>
                </li>
              </OverlayTrigger>
            );
          })}
        </ul>
        
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default ProjectInsightLogin;